import React, { useEffect, useState } from 'react'

import BasketProvider from './context/BasketContext'
import Content from './components/ui/Content'
import Navigation from './components/Navigation'
import ProductsProvider from './context/ProductsContext'
import CheckoutProvider from './context/CheckoutContext'
import ReturnServiceProvider from './context/ReturnServiceContext'
import CategoryProvider from './context/CategoryContext'
import OrderProvider from './context/OrderContext'

export default function SalesAppRoot(props) {
  const [isExpanded, setIsExpanded] = useState(false)

  function useSetIsExpanded(value) {
    setIsExpanded(value)
    localStorage.setItem('openDrawer', JSON.stringify(value))
  }

  function getDrawerStatus() {
    let o = localStorage.getItem('openDrawer')
    return !o ? true : JSON.parse(o)
  }

  useEffect(() => {
    setIsExpanded(getDrawerStatus())

    const mm = window.matchMedia("(max-width: 1366px)");
    mm.addEventListener('change', () => {
      if (mm.matches) {
        setIsExpanded(false)
      } else {
        setIsExpanded(getDrawerStatus())
      }
    })
  }, [])

  return (
    <ProductsProvider>
      <CheckoutProvider>
        <BasketProvider>
          <ReturnServiceProvider>
            <CategoryProvider>
              <OrderProvider>
                <Navigation
                  isExpanded={isExpanded}
                  expandDrawer={useSetIsExpanded}
                />
                <Content
                  isExpanded={isExpanded}
                  match={props.match}
                  // isExpanded={isExpanded}
                  // match={props.match}
                />
              </OrderProvider>
            </CategoryProvider>
          </ReturnServiceProvider>
        </BasketProvider>
      </CheckoutProvider>
    </ProductsProvider>
  )
}
